var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, Divider, styled, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useReducer, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { calculateRoofPressures, calculateRoofPressuresWithFlashingRating, calculateWallPressures } from '../../../services/RatingsCalculatorService';
import theme from '../../../theme';
import { ApplicationContext } from '../../ApplicationProvider';
import { ConfigitContext } from '../../ConfigitProvider';
import { DIRECTIONALITY_FACTOR, EFFECTIVE_WIND_AREA, ELEVATION_MEAN, IMPORTANCE_FACTOR, SAFETY_FACTOR, SLOPE_DEGREE, SLOPE_RISE, TOPOGRAPHICAL_FACTOR } from '../../constants/CALCULATOR_VALUES';
import { ButtonComponent } from '../../shared/ButtonComponent/ButtonComponent';
import { SelectComponent } from '../../shared/SelectComponent/SelectComponent';
import { SummaryRatings } from './SummaryRatings';
import { SummaryTables } from './SummaryTables';
import { useMsal } from '@azure/msal-react';
import { getProjectsByEmail, saveUserProject } from '../../../services/ProjectService';
import { genrateUuidv4 } from '../../../services/ScenarioService';
import { getRoofAreaInfoById, getRoofAreasByProjectId, saveBaseRoofAreaIncludingRating } from '../../../services/RoofAreaService';
import { ErrorModalComponent } from '../../shared/ErrorModalComponent/ErrorModalComponent';
import { Dialog } from '../../shared/DialogComponent/Dialog';
import { SnackbarComponent } from '../../shared/SnackbarComponent';
import { Length } from '../../../utils/Measurement/Length';
import { filterWallResult, getWindUpliftByZone, getZoneImage, mapRoofAreaRatingResult, mapRoofAreaWallRatingResult, mapWindBorneData, mapZoneData, sortCalc } from '../CalcHelper';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SummaryTextField = styled(TextField)({ '& .MuiInputBase-root': { width: '273px' } });
export var SummaryComponent = function () {
    var navigate = useNavigate();
    var _a = useContext(ApplicationContext), setDefaultTab = _a.setDefaultTab, setDialog = _a.setDialog, setShowDialog = _a.setShowDialog, calcRatingRoofId = _a.calcRatingRoofId, calcRatingProjectId = _a.calcRatingProjectId, setCalcRatingProjectId = _a.setCalcRatingProjectId, setCalcRatingRoofId = _a.setCalcRatingRoofId;
    var updateConfigitCriteria = useContext(ConfigitContext).updateConfigitCriteria;
    var _b = useState(''), selectedZone = _b[0], setSelectedZone = _b[1];
    var _c = React.useState(false), open = _c[0], setOpen = _c[1];
    var currentCalculatorVersion = process.env.REACT_APP_CALCULATOR_VERSION ? process.env.REACT_APP_CALCULATOR_VERSION : 'none detected';
    var ratingData = [];
    var selectSurfaceRoughness = function (state) { return state.calculator.windRatingState.surfaceRoughness; };
    var selectWindSpeed = function (state) { return state.calculator.windRatingState.windSpeed; };
    var selectEnclosureClassification = function (state) { return state.calculator.windRatingState.enclosureClassification; };
    var selectCycloneProne = function (state) { return state.calculator.windRatingState.cycloneProneLocation; };
    var selectRoofAreaHeight = function (state) { return state.calculator.windRatingState.roofAreaHeight; };
    var selectRoofAreaSlope = function (state) { return state.calculator.windRatingState.roofAreaSlope; };
    var selectRoofAreaWidth = function (state) { return state.calculator.windRatingState.roofAreaWidth; };
    var selectRoofAreaLength = function (state) { return state.calculator.windRatingState.roofAreaLength; };
    var selectHasParapet = function (state) { return state.calculator.windRatingState.hasParapet; };
    var selectHailRating = function (state) { return state.calculator.hailRatingState.hailRating; };
    var selectInternalFire = function (state) { return state.calculator.fireRatingState.internalFireRating; };
    var selectExternalFire = function (state) { return state.calculator.fireRatingState.externalFireRating; };
    var selectIsRiseRun = function (state) { return state.calculator.windRatingState.isRiseRun; };
    var surfaceRoughness = useSelector(selectSurfaceRoughness);
    var windSpeed = useSelector(selectWindSpeed);
    var enclosureClassification = useSelector(selectEnclosureClassification);
    var cycloneProne = useSelector(selectCycloneProne);
    var roofAreaHeight = useSelector(selectRoofAreaHeight);
    var roofAreaLength = useSelector(selectRoofAreaLength);
    var roofAreaSlope = useSelector(selectRoofAreaSlope);
    var roofAreaWidth = useSelector(selectRoofAreaWidth);
    var hasParapet = useSelector(selectHasParapet);
    var hailRating = useSelector(selectHailRating);
    var internalFire = useSelector(selectInternalFire);
    var externalFire = useSelector(selectExternalFire);
    var isRiseRun = useSelector(selectIsRiseRun);
    var _d = useState(ratingData), calcResult = _d[0], setCalcResult = _d[1];
    var _e = useState([]), wallResult = _e[0], setWallResult = _e[1];
    var _f = useState(), userProjects = _f[0], setUserProjects = _f[1];
    var _g = useState(), userRoofAreas = _g[0], setUserRoofAreas = _g[1];
    var _h = useState(false), apiErrorCheck = _h[0], setApiErrorCheck = _h[1];
    var selectedProject = useRef('');
    var selectedRoofArea = useRef('');
    var _j = useState(''), newProjectName = _j[0], setNewProjectName = _j[1];
    var _k = useState(''), newRoofAreaName = _k[0], setNewRoofAreaName = _k[1];
    var forceUpdate = useReducer(function (x) { return x + 1; }, 0)[1];
    var _l = useState(false), errorCheck = _l[0], setErrorCheck = _l[1];
    var azureADPCA = useMsal().instance; // Slope values sent to configit are needed in rise/run
    var checkSlopeValues = function () { if (isRiseRun) {
        return roofAreaSlope;
    }
    else {
        for (var i = 0; i < SLOPE_DEGREE.length; i++) {
            if (roofAreaSlope == SLOPE_DEGREE[i].value) {
                return SLOPE_RISE[i].value;
            }
        }
    } }; // slope values sent to caluclator API are needed in degrees
    var getSlopeDegree = function () { if (!isRiseRun) {
        return roofAreaSlope;
    }
    else {
        for (var i = 0; i < SLOPE_RISE.length; i++) {
            if (roofAreaSlope == SLOPE_RISE[i].value) {
                return SLOPE_DEGREE[i].value;
            }
        }
    } };
    var calcData = { surfaceRoughness: surfaceRoughness.value, windSpeed: Number(windSpeed), enclosureClassification: enclosureClassification.value, width: Math.min(Number(roofAreaWidth), Number(roofAreaLength)), roofHeight: Number(roofAreaHeight), wallComponentHeight: Number(roofAreaHeight), highestOpeningHeight: Number(roofAreaHeight), roofSlope: Number(getSlopeDegree()), isContinuousParapet: hasParapet, effectiveWindArea: EFFECTIVE_WIND_AREA, isTropicalCycloneRegion: cycloneProne, directionalityFactor: DIRECTIONALITY_FACTOR, elevationMean: ELEVATION_MEAN, topographicalFactor: TOPOGRAPHICAL_FACTOR, importanceFactor: IMPORTANCE_FACTOR, safetyFactor: SAFETY_FACTOR };
    var getUserEmail = function () {
        var _azureADPCA$getActive, _azureADPCA$getActive2;
        var userEmail = ((_azureADPCA$getActive = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive === void 0 ? void 0 : _azureADPCA$getActive.username) || 'test@test.com'; // works for initial Azure B2C before customization
        // For customized Azure B2C, user email needs to be retrieved as follows:
        var tokenClaims;
        var userGUID;
        if ((_azureADPCA$getActive2 = azureADPCA.getActiveAccount()) !== null && _azureADPCA$getActive2 !== void 0 && _azureADPCA$getActive2.idTokenClaims) {
            var _azureADPCA$getActive3, _azureADPCA$getActive4;
            tokenClaims = (_azureADPCA$getActive3 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive3 === void 0 ? void 0 : _azureADPCA$getActive3.idTokenClaims;
            if (tokenClaims && tokenClaims.hasOwnProperty('email')) {
                userEmail = tokenClaims['email'];
            } //  if (tokenClaims && tokenClaims.hasOwnProperty('aud')) {
            userGUID = (_azureADPCA$getActive4 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive4 === void 0 ? void 0 : _azureADPCA$getActive4.localAccountId;
        }
        return userEmail;
    };
    useEffect(function () { var getCalcData = function () { return __awaiter(void 0, void 0, void 0, function () { var calcCallResult, calcWallResult, calcCallResultWithFlashing, calcWallResult; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(enclosureClassification.value === 2)) return [3 /*break*/, 3];
                return [4 /*yield*/, calculateRoofPressures(calcData)];
            case 1:
                calcCallResult = _a.sent();
                calcCallResult.sort(function (a, b) { return sortCalc(a, b); });
                return [4 /*yield*/, calculateWallPressures(calcData)];
            case 2:
                calcWallResult = _a.sent();
                setCalcResult(calcCallResult);
                setWallResult(filterWallResult(calcWallResult));
                return [3 /*break*/, 6];
            case 3: return [4 /*yield*/, calculateRoofPressuresWithFlashingRating(calcData)];
            case 4:
                calcCallResultWithFlashing = _a.sent();
                calcCallResultWithFlashing.sort(function (a, b) { return sortCalc(a, b); });
                return [4 /*yield*/, calculateWallPressures(calcData)];
            case 5:
                calcWallResult = _a.sent();
                setCalcResult(calcCallResultWithFlashing);
                setWallResult(filterWallResult(calcWallResult));
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    }); }); }; var getRoofProjects = function () { return __awaiter(void 0, void 0, void 0, function () { var email, projectData; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                email = getUserEmail();
                return [4 /*yield*/, getProjectsByEmail(email, genrateUuidv4())];
            case 1:
                projectData = _a.sent();
                mapProjects(projectData);
                return [2 /*return*/];
        }
    }); }); }; var setInitialData = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                selectedProject.current = calcRatingProjectId;
                if (calcRatingRoofId > 0)
                    selectedRoofArea.current = calcRatingRoofId;
                return [4 /*yield*/, changeSelectedProject(String(selectedProject.current))];
            case 1:
                _a.sent();
                selectedRoofArea.current = calcRatingRoofId;
                return [2 /*return*/];
        }
    }); }); }; getCalcData(); getRoofProjects(); if (calcRatingProjectId > 0) {
        setInitialData();
    } console.log({ calcResult: calcResult }); }, []);
    useEffect(function () {
        // completion planned once work begins on loading and editing saved roof area calculations
        if (apiErrorCheck) {
            setDialog(/*#__PURE__*/ _jsx(Dialog, { label: "An Error Occurred", children: /*#__PURE__*/ _jsx(ErrorModalComponent, { message: "Please check data and resubmit" }) }));
            setShowDialog(true);
        }
    }, [apiErrorCheck]);
    var mapProjects = function (projects) { var projectMapping = [{ name: 'Create New Project', value: 0 }]; projects.forEach(function (project) { projectMapping.push({ value: project.ProjectId, name: project.Name }); }); setUserProjects(projectMapping); };
    var mapRoofAreas = function (roofAreas) { var roofAreaMapping = [{ name: 'Create New Roof Area', value: 0 }]; roofAreas.forEach(function (roofArea) { roofAreaMapping.push({ value: roofArea.RoofAreaId, name: roofArea.Name }); }); setUserRoofAreas(roofAreaMapping); };
    var onProjectNameSelected = function (e) { if (e.target.value) {
        setNewProjectName(e.target.value);
        setErrorCheck(false);
    }
    else {
        setNewProjectName('');
        setErrorCheck(false);
    } };
    var onRoofAreaNameSelected = function (e) { if (e.target.value) {
        setNewRoofAreaName(e.target.value);
        setErrorCheck(false);
    }
    else {
        setNewRoofAreaName('');
        setErrorCheck(false);
    } };
    var handleSearchClick = function () {
        var _hailRating$value, _internalFire$value, _externalFire$value;
        if (selectedZone === '')
            return false;
        var assemblyProp = []; // Hail Rating
        var variableHailRating = {};
        variableHailRating.variableId = 'C_HailRating_HailRatingId';
        variableHailRating.value = (_hailRating$value = hailRating.value) === null || _hailRating$value === void 0 ? void 0 : _hailRating$value.toString();
        assemblyProp.push(variableHailRating); // Internal Fire
        var variableInternalFire = {};
        variableInternalFire.variableId = 'C_IntFireRating_IntFireRatingId';
        variableInternalFire.value = (_internalFire$value = internalFire.value) === null || _internalFire$value === void 0 ? void 0 : _internalFire$value.toString();
        assemblyProp.push(variableInternalFire); // External Fire
        var variableExternalFire = {};
        variableExternalFire.variableId = 'C_ExtFireRating_ExtFireRatingId';
        variableExternalFire.value = (_externalFire$value = externalFire.value) === null || _externalFire$value === void 0 ? void 0 : _externalFire$value.toString();
        assemblyProp.push(variableExternalFire); // Slope
        var variableSlopeValue = {};
        variableSlopeValue.variableId = 'NavAssembly_Slope_view';
        variableSlopeValue.value = checkSlopeValues();
        assemblyProp.push(variableSlopeValue);
        var variableSlopeOperator = {};
        variableSlopeOperator.variableId = 'SlopeOperator';
        variableSlopeOperator.value = 'Equal';
        assemblyProp.push(variableSlopeOperator); // Wind Uplift
        var variableWindUpliftValue = {};
        variableWindUpliftValue.variableId = 'NavAssembly_WindUplift_view';
        variableWindUpliftValue.value = getWindUpliftByZone(Number(selectedZone), calcResult);
        assemblyProp.push(variableWindUpliftValue);
        var variableWindUpliftOperator = {};
        variableWindUpliftOperator.variableId = 'WindUpliftOperator';
        variableWindUpliftOperator.value = 'BiggerOrEqual';
        assemblyProp.push(variableWindUpliftOperator);
        updateConfigitCriteria(assemblyProp, [], []);
        setDefaultTab(0);
        setCalcRatingProjectId(-1);
        setCalcRatingRoofId(-1);
        navigate('/assembliesListing?openRoofLayers=true&openAssemblyProps=true');
    };
    var roofMapResult = getZoneImage(Number(getSlopeDegree()), roofAreaHeight, roofAreaWidth, roofAreaLength);
    var mapRatingInput = function () {
        var ratingInput = { BuildingEnclosureId: 1, CalculatorVersion: currentCalculatorVersion, ContinuousParapet: hasParapet, // EnteredAsMetric: !isRiseRun,
            ExtFireRatingId: Number(externalFire.value), GroundRoughnessRatingId: Number(surfaceRoughness.value) + 1, HailRatingId: Number(hailRating.value), Height: Number(roofAreaHeight) * 12 * Length.INCH_TO_MM, IntFireRatingId: Number(internalFire.value), Length: Number(roofAreaLength) * 12 * Length.INCH_TO_MM, Slope: Number(checkSlopeValues()), TropicalCycloneRegion: cycloneProne, Width: Number(roofAreaWidth) * 12 * Length.INCH_TO_MM, WindBorneDebrisId: mapWindBorneData(Number(enclosureClassification.value)), WindSpeed: Number(windSpeed) };
        return ratingInput;
    };
    var saveCalcData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newProjectId, _azureADPCA$getActive5, _azureADPCA$getActive6, userEmail, tokenClaims, userGUID, _azureADPCA$getActive7, _azureADPCA$getActive8, newProject, roofAreaRatingInput, roofAreaRatingResult, roofAreaWallRatingResult, roofAreaBaseInfo, roofAreaToSave, roofAreaFullData, saveData, randguid, roofAreas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setApiErrorCheck(false);
                    newProjectId = undefined;
                    if (!(selectedProject.current === 0)) return [3 /*break*/, 2];
                    userEmail = ((_azureADPCA$getActive5 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive5 === void 0 ? void 0 : _azureADPCA$getActive5.username) || 'test@test.com';
                    tokenClaims = void 0;
                    userGUID = void 0;
                    if ((_azureADPCA$getActive6 = azureADPCA.getActiveAccount()) !== null && _azureADPCA$getActive6 !== void 0 && _azureADPCA$getActive6.idTokenClaims) {
                        tokenClaims = (_azureADPCA$getActive7 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive7 === void 0 ? void 0 : _azureADPCA$getActive7.idTokenClaims;
                        if (tokenClaims && tokenClaims.hasOwnProperty('email')) {
                            userEmail = tokenClaims['email'];
                        }
                        userGUID = (_azureADPCA$getActive8 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive8 === void 0 ? void 0 : _azureADPCA$getActive8.localAccountId;
                    }
                    newProject = { Name: newProjectName, AzureB2CUserEmail: userEmail, AzureB2CUserGuid: userGUID };
                    return [4 /*yield*/, saveUserProject({ Project: newProject, SaveOperationType: 1 })];
                case 1:
                    newProjectId = _a.sent();
                    if (!newProjectId) {
                        setApiErrorCheck(true);
                        return [2 /*return*/];
                    }
                    _a.label = 2;
                case 2:
                    roofAreaRatingInput = mapRatingInput();
                    roofAreaRatingResult = mapRoofAreaRatingResult(calcResult);
                    roofAreaWallRatingResult = mapRoofAreaWallRatingResult(wallResult);
                    roofAreaBaseInfo = {};
                    if (!(Number(selectedRoofArea.current) > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, getRoofAreaInfoById(Number(selectedRoofArea.current))];
                case 3:
                    roofAreaToSave = _a.sent();
                    roofAreaBaseInfo = { RoofAreaId: roofAreaToSave[0].RoofAreaId, ProjectId: roofAreaToSave[0].RoofProject.ProjectId, Name: roofAreaToSave[0].Name, Description: roofAreaToSave[0].Description, BuildingName: roofAreaToSave[0].BuildingName };
                    return [3 /*break*/, 5];
                case 4:
                    roofAreaBaseInfo = { Name: newRoofAreaName, ProjectId: newProjectId ? newProjectId : Number(selectedProject.current) };
                    _a.label = 5;
                case 5:
                    roofAreaFullData = { RoofAreaBase: roofAreaBaseInfo, RoofAreaRatingInput: roofAreaRatingInput, RoofAreaRatingResult: roofAreaRatingResult, RoofAreaWallRatingResult: roofAreaWallRatingResult, SaveOperationType: Number(selectedRoofArea.current) > 0 ? 2 : 1 };
                    return [4 /*yield*/, saveBaseRoofAreaIncludingRating(roofAreaFullData)];
                case 6:
                    saveData = _a.sent();
                    if (!saveData) return [3 /*break*/, 9];
                    setOpen(true);
                    setTimeout(function () { setOpen(false); }, 3000);
                    if (!(roofAreaFullData.SaveOperationType === 1 && roofAreaBaseInfo.ProjectId && roofAreaBaseInfo.RoofAreaId)) return [3 /*break*/, 8];
                    randguid = genrateUuidv4();
                    return [4 /*yield*/, getRoofAreasByProjectId(roofAreaBaseInfo.ProjectId, randguid)];
                case 7:
                    roofAreas = _a.sent();
                    mapRoofAreas(roofAreas);
                    selectedRoofArea.current = roofAreaBaseInfo.RoofAreaId;
                    changeSelectedProject(String(selectedProject.current));
                    forceUpdate();
                    _a.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    setNewProjectName('');
                    setNewRoofAreaName('');
                    setApiErrorCheck(true);
                    return [2 /*return*/];
                case 10:
                    setNewProjectName('');
                    setNewRoofAreaName('');
                    setCalcRatingProjectId(-1);
                    setCalcRatingRoofId(-1);
                    return [2 /*return*/];
            }
        });
    }); };
    var changeSelectedProject = function (value) { return __awaiter(void 0, void 0, void 0, function () { var roofAreas, randguid; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (value.length === 0) {
                    selectedProject.current = '';
                    selectedRoofArea.current = '';
                    forceUpdate();
                    return [2 /*return*/];
                }
                else {
                    selectedProject.current = Number(value);
                }
                if (selectedProject.current === 0) {
                    selectedRoofArea.current = 0;
                    forceUpdate();
                }
                if (!(selectedProject.current > 0)) return [3 /*break*/, 2];
                selectedRoofArea.current = -1;
                randguid = genrateUuidv4();
                return [4 /*yield*/, getRoofAreasByProjectId(selectedProject.current, randguid)];
            case 1:
                roofAreas = _a.sent();
                mapRoofAreas(roofAreas);
                forceUpdate();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    }); }); };
    var changeSelectedRoofArea = function (value) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        if (value.length === 0) {
            selectedRoofArea.current = -1;
        }
        else {
            selectedRoofArea.current = Number(value);
        }
        forceUpdate();
        return [2 /*return*/];
    }); }); };
    var handleClose = function (event, reason) { if (event) {
        setOpen(false);
        return;
    } };
    var preflightCheck = function () { if (selectedProject.current === '' || selectedRoofArea.current === '')
        return true; if (selectedProject.current === 0 && newProjectName.length === 0)
        return true; if (selectedRoofArea.current === 0 && newRoofAreaName.length === 0)
        return true; if (selectedRoofArea.current === -1)
        return true; return false; };
    return /*#__PURE__*/ _jsxs(Box, { className: 'px-4 rn-summary', children: [/*#__PURE__*/ _jsx(Typography, { className: 'headline-1 py-5', color: theme.palette.rnSteel.steel700, children: "Summary" }), /*#__PURE__*/ _jsxs(Typography, { className: "large-para pb-4", children: ["Below is a summary of your personalized calculations. You can ", /*#__PURE__*/ _jsx("b", { children: "save" }), " these calculations to a Roof Area and", ' ', /*#__PURE__*/ _jsx("b", { children: "search" }), " for assemblies with your calculations pre-populated. For further guidance, refer to the FM Data Sheets."] }), /*#__PURE__*/ _jsx(Typography, { className: "headline-3", children: "Save Ratings" }), /*#__PURE__*/ _jsxs("div", { className: "row m-0", children: [/*#__PURE__*/ _jsxs("div", { className: "mr-4 mb-2", children: [/*#__PURE__*/ _jsxs("div", { className: "row m-0", children: [/*#__PURE__*/ _jsxs("div", { className: "mr-4 mb-2", children: [/*#__PURE__*/ _jsx(Typography, { className: "summary-select modal-info-bold-text pb-1", children: "Project" }), /*#__PURE__*/ _jsx(SelectComponent, { options: userProjects !== null && userProjects !== void 0 ? userProjects : [{ name: 'Create New Project', value: 0 }], setValue: function (value) { return changeSelectedProject(value); }, value: String(selectedProject.current), className: "as-2 summary-select" })] }), /*#__PURE__*/ _jsxs("div", { className: "as-2 mb-2", children: [/*#__PURE__*/ _jsx(Typography, { className: "summary-select modal-info-bold-text pb-1", children: "Roof Area" }), /*#__PURE__*/ _jsx(SelectComponent, { disabled: selectedProject.current === 0, options: userRoofAreas !== null && userRoofAreas !== void 0 ? userRoofAreas : [{ name: 'Create New Roof Area', value: 0 }], setValue: function (value) { return changeSelectedRoofArea(value); }, value: String(selectedRoofArea.current), className: "as-2 summary-select" })] })] }), /*#__PURE__*/ _jsxs("div", { className: "row m-0", children: [selectedProject.current === 0 ? /*#__PURE__*/ _jsxs("div", { className: "mr-4 mb-2", children: [/*#__PURE__*/ _jsxs(Typography, { className: "summary-select modal-info-bold-text pb-1", children: ["Project Name: ", /*#__PURE__*/ _jsx("span", { className: "roofnav-error", children: "*" })] }), /*#__PURE__*/ _jsx(SummaryTextField, { value: newProjectName, onChange: onProjectNameSelected, id: "projectNameInput", placeholder: "Project Name", className: "as-2", size: "small", error: errorCheck && newProjectName.length == 0 })] }) : /*#__PURE__*/ _jsx("div", { className: "mr-4 empty-slot mb-2", children: " \xA0" }), selectedRoofArea.current === 0 ? /*#__PURE__*/ _jsxs("div", { className: "mb-2", children: [/*#__PURE__*/ _jsxs(Typography, { className: "summary-select modal-info-bold-text pb-1", children: ["Roof Area Name: ", /*#__PURE__*/ _jsx("span", { className: "roofnav-error", children: "*" })] }), /*#__PURE__*/ _jsx(SummaryTextField, { value: newRoofAreaName, onChange: onRoofAreaNameSelected, id: "roofAreaNameInput", placeholder: "Roof Area Name", className: "as-2", size: "small", error: errorCheck && newRoofAreaName.length == 0 })] }) : /*#__PURE__*/ _jsx("div", { className: "as-2" })] })] }), /*#__PURE__*/ _jsx(ButtonComponent, { buttonStyle: "mt-4 mb-2 mx-0", isDisabled: preflightCheck(), buttonText: "Save Ratings", buttonType: 'primary', click: function () { return saveCalcData(); } })] }), /*#__PURE__*/ _jsx(Typography, { className: 'headline-3', color: theme.palette.rnSteel.steel700, children: "Assembly Search" }), /*#__PURE__*/ _jsx(Typography, { className: 'modal-info-bold-text', children: "Area of Roof" }), /*#__PURE__*/ _jsxs("div", { className: 'row m-0 px-0 pb-5 d-flex align-items-center', children: [/*#__PURE__*/ _jsx(SelectComponent, { id: "searchAssembliesSelect", options: mapZoneData(calcResult), setValue: function (value) { return setSelectedZone(value); }, value: selectedZone, className: "as-2 summary-select" }), /*#__PURE__*/ _jsx(ButtonComponent, { isDisabled: selectedZone.length === 0, id: 'searchAssembliesButton', buttonType: 'primary', buttonText: 'Search Assemblies', iconName: "search", buttonStyle: 'ml-4', click: handleSearchClick })] }), /*#__PURE__*/ _jsx(Divider, {}), /*#__PURE__*/ _jsx(SummaryTables, {}), /*#__PURE__*/ _jsx(SummaryRatings, { calcResult: calcResult, wallResult: wallResult }), roofMapResult ? /*#__PURE__*/ _jsx("img", { src: "/assets/".concat(roofMapResult, ".png"), alt: "".concat(roofMapResult), "aria-label": "".concat(roofMapResult) }) : /*#__PURE__*/ _jsx(_Fragment, {}), /*#__PURE__*/ _jsx(SnackbarComponent, { open: open, handleClose: handleClose, message: 'Roof Area successfully saved' })] });
};
